var _rect, _path, _path2, _path3, _path4, _circle, _path5, _circle2, _circle3, _circle4, _circle5, _path6, _path7, _path8, _path9, _path0, _circle6, _path1, _circle7, _circle8, _circle9, _circle0, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 18,
    fill: "#ffe2dc"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 14,
    y: 14,
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD6DD",
    d: "M24 29l5-5L6 1H1v5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9AAAB4",
    d: "M1 1v5l23 23 2.5-2.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D99E82",
    d: "M33.424 32.808c.284-.284.458-.626.531-.968l-5.242-6.195-.701-.702c-.564-.564-1.57-.473-2.248.205l-.614.612c-.677.677-.768 1.683-.204 2.247l.741.741 6.15 5.205c.345-.072.688-.247.974-.532l.613-.613z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.424 32.808c.284-.284.458-.626.531-.968l-1.342-1.586-.737 3.684c.331-.077.661-.243.935-.518l.613-.612zm-3.31-5.506l-.888 4.441 1.26 1.066.82-4.1zm-1.401-1.657l-.701-.702c-.096-.096-.208-.166-.326-.224l-.978 4.892 1.26 1.066.957-4.783-.212-.249zm-2.401-.888c-.195.095-.382.225-.548.392l-.614.611c-.254.254-.425.554-.511.86-.142.51-.046 1.035.307 1.387l.596.596.77-3.846c0-.001 0-.001 0 0z",
    fill: "#BF6952"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#8A4633",
    cx: 33.25,
    cy: 33.25,
    r: 2.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M29.626 22.324c.404.404.404 1.059 0 1.462l-6.092 6.092c-.404.404-1.058.404-1.462 0-.404-.404-.404-1.058 0-1.462l6.092-6.092c.402-.404 1.058-.404 1.462 0z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAC33",
    cx: 22.072,
    cy: 29.877,
    r: 1.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAC33",
    cx: 29.626,
    cy: 22.323,
    r: 1.75
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFCC4D",
    cx: 22.072,
    cy: 29.877,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFCC4D",
    cx: 29.626,
    cy: 22.323,
    r: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M33.903 29.342c.298.298.298.781 0 1.078l-3.476 3.475c-.298.298-.78.298-1.078 0-.298-.298-.298-.78 0-1.078l3.476-3.475c.297-.298.78-.298 1.078 0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD6DD",
    d: "M12 29l-5-5L30 1h5v5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#9AAAB4",
    d: "M35 1v5L12 29l-2.5-2.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D99E82",
    d: "M2.576 32.808c-.284-.284-.458-.626-.531-.968l5.242-6.195.701-.702c.564-.564 1.57-.473 2.248.205l.613.612c.677.677.768 1.683.204 2.247l-.741.741-6.15 5.205c-.345-.072-.688-.247-.974-.532l-.612-.613z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2.576 32.808c-.284-.284-.458-.626-.531-.968l1.342-1.586.737 3.684c-.331-.077-.661-.243-.935-.518l-.613-.612zm3.31-5.506l.888 4.441-1.26 1.066-.82-4.1zm1.401-1.657l.701-.702c.096-.096.208-.166.326-.224l.978 4.892-1.26 1.066-.957-4.783.212-.249zm2.401-.888c.195.095.382.225.548.392l.613.612c.254.254.425.554.511.86.142.51.046 1.035-.307 1.387l-.596.596-.769-3.847c0-.001 0-.001 0 0z",
    fill: "#BF6952"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#8A4633",
    cx: 2.75,
    cy: 33.25,
    r: 2.75
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M6.374 22.324c-.404.404-.404 1.059 0 1.462l6.092 6.092c.404.404 1.058.404 1.462 0 .404-.404.404-1.058 0-1.462l-6.092-6.092c-.402-.404-1.058-.404-1.462 0z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAC33",
    cx: 13.928,
    cy: 29.877,
    r: 1.75
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAC33",
    cx: 6.374,
    cy: 22.323,
    r: 1.75
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFCC4D",
    cx: 13.928,
    cy: 29.877,
    r: 1
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFCC4D",
    cx: 6.374,
    cy: 22.323,
    r: 1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M2.097 29.342c-.298.298-.298.781 0 1.078l3.476 3.475c.298.298.78.298 1.078 0 .298-.298.298-.78 0-1.078l-3.476-3.475c-.297-.298-.78-.298-1.078 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatAction);
export default __webpack_public_path__ + "static/media/cat-action.ce4ca8b31e3520b26f0e6c4263e9762c.svg";
export { ForwardRef as ReactComponent };